export default __webpack_public_path__ + "static/media/contrato_esterilizacion.05f502af.docx";